/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.WorkshopQuestionnaireQuestion = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The WorkshopQuestionnaireQuestion model module.
   * @module model/WorkshopQuestionnaireQuestion
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>WorkshopQuestionnaireQuestion</code>.
   * @alias module:model/WorkshopQuestionnaireQuestion
   * @class
   */
  var exports = function() {
    var _this = this;








  };

  /**
   * Constructs a <code>WorkshopQuestionnaireQuestion</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/WorkshopQuestionnaireQuestion} obj Optional instance to populate.
   * @return {module:model/WorkshopQuestionnaireQuestion} The populated <code>WorkshopQuestionnaireQuestion</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Question')) {
        obj['Question'] = ApiClient.convertToType(data['Question'], 'String');
      }
      if (data.hasOwnProperty('QuestionTypeID')) {
        obj['QuestionTypeID'] = ApiClient.convertToType(data['QuestionTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('IsMandatory')) {
        obj['IsMandatory'] = ApiClient.convertToType(data['IsMandatory'], 'Boolean');
      }
      if (data.hasOwnProperty('PerformanceIndicatorID')) {
        obj['PerformanceIndicatorID'] = ApiClient.convertToType(data['PerformanceIndicatorID'], 'Integer');
      }
      if (data.hasOwnProperty('WidgetID')) {
        obj['WidgetID'] = ApiClient.convertToType(data['WidgetID'], 'Integer');
      }
      if (data.hasOwnProperty('Sort')) {
        obj['Sort'] = ApiClient.convertToType(data['Sort'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {String} Question
   * @default ''
   */
  exports.prototype['Question'] = '';
  /**
   * @member {Integer} QuestionTypeID
   * @default 0
   */
  exports.prototype['QuestionTypeID'] = 0;
  /**
   * @member {Boolean} IsMandatory
   * @default false
   */
  exports.prototype['IsMandatory'] = false;
  /**
   * @member {Integer} PerformanceIndicatorID
   */
  exports.prototype['PerformanceIndicatorID'] = undefined;
  /**
   * @member {Integer} WidgetID
   * @default 0
   */
  exports.prototype['WidgetID'] = 0;
  /**
   * @member {Integer} Sort
   * @default 0
   */
  exports.prototype['Sort'] = 0;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


